var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GChart',{attrs:{"type":"LineChart","data":_vm.initialData,"options":_vm.chartOptions,"events":_vm.chartEvents},on:{"ready":_vm.onChartReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }